import { render, staticRenderFns } from "./ProvidusIssueCardList.vue?vue&type=template&id=1ddc6c22&scoped=true&"
import script from "./ProvidusIssueCardList.vue?vue&type=script&lang=js&"
export * from "./ProvidusIssueCardList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidusIssueCardList.vue?vue&type=style&index=0&id=1ddc6c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc6c22",
  null
  
)

export default component.exports